import React, { useState, useCallback, useEffect } from "react";
import { Box } from "@mui/system";
import styles from "./vehicleIconComponent.module.scss";
import moment from "moment";
import _ from "lodash";
import { getLogoIcon } from "../../../../Dealers/components/dealerDetails/logoComponent/LogoComponent";
import UpdateVehicleStatus from "../../updateVehicleStatus/updateVehicleStatus";
import CustomModalDialog from "../../../../../components/modal/CustomModalDialog";
import {
  sendCertificateMail,
  getCertificatesList,
  previewVehicleCertificateTemplate,
  deleteVehicleCertificateTemplate,
} from "../../../../../services/APIService";
import { useApiErrorModalContext } from "../../../../../errorHandling/ApiErrorModalContext";
import PropTypes from "prop-types";
import LoaderSpinnerComponent from "../../../../../components/loader/LoaderSpinnerComponent";

const VehicelIconComponent = (props) => {
  const {
    vehicleId,
    certificatesList,
    refreshTable,
    vehicle,
    setOpenSnackBar,
    setEmailStatus,
  } = props;
  const [isShowModalFlag, setIsShowModalFlag] = useState(false);
  const [isShowLoader, setIsShowLoader] = useState(false);
  const [deleteCertificate, setDeleteCertificate] = useState([]);
  const { setApiErrorModalState } = useApiErrorModalContext();
  const [certificatesOptions, setCertificatesOptions] = useState([]);
  const combainedCertificate = certificatesList?.filter(
    (option) => option.certificate_Name === "Combined_Certificate"
  );

  const getCertificateListOptions = useCallback(() => {
    getCertificatesList({})
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
          setEmailStatus(false);
          setOpenSnackBar(true);
        } else {
          setCertificatesOptions(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    getCertificateListOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sentMail = (certificate) => {
    let selectedCertificate = [];
    if (certificate.certificate_Name === "Combined_Certificate") {
      selectedCertificate = {
        key: "Combined_Certificate",
        value: "Combined_Certificate",
        id: 6,
      };
    } else {
      selectedCertificate = certificatesOptions.filter(
        (option) => option.value === certificate?.certificate_Name
      )[0];
    }
    setIsShowLoader(true);
    sendCertificateMail({
      VehicleId: vehicle?.vehicle_Id,
      CertificateId: selectedCertificate?.id,
    }).then((response) => {
      setIsShowLoader(false);
      if (
        !_.isEmpty(_.get(response, "errorMessage", "")) ||
        _.get(response, "success", true) === false
      ) {
        _.set(response, "status", 200);
        setApiErrorModalState({ error: response });
      } else {
        setOpenSnackBar(true);
      }
    }).catch((e) => {
      setIsShowLoader(false);
    });
  };

  const handleDeleteCertificate = (vehicleId, certificate) => {
    let selectedCertificate = [];
    if (certificate.certificate_Name === "Combined_Certificate") {
      selectedCertificate = {
        key: "Combined_Certificate",
        value: "Combined_Certificate",
        id: 6,
      };
    } else {
      selectedCertificate = certificatesOptions.filter(
        (option) => option.value === certificate?.certificate_Name
      )[0];
    }
    deleteVehicleCertificateTemplate({
      vehicleId: vehicleId,
      certificateId: selectedCertificate.id,
      certificate: certificate?.certificate_Name,
    })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          refreshTable();
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };

    const handleViewCertificate = (vehicleId, certificate) => {
    let selectedCertificate = [];
    if (certificate.certificate_Name === "Combined_Certificate") {
      selectedCertificate = {
        key: "Combined_Certificate",
        value: "Combined_Certificate",
        id: 6,
      };
    } else {
      selectedCertificate = certificatesOptions.find(
        (option) => option.value === certificate?.certificate_Name
      );
    }
    setIsShowLoader(true);
    previewVehicleCertificateTemplate({
      vehicleId: vehicleId,
      certificateId: selectedCertificate?.id,
    })
      .then((pdfBlob) => {
        setIsShowLoader(false);

        const pdfUrl = window.URL.createObjectURL(pdfBlob);

        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = 'Vehicle_Certificate.pdf';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
          window.URL.revokeObjectURL(pdfUrl);
        }, 1000);
        refreshTable();
      })
      .catch((err) => {
        setIsShowLoader(false);
        setApiErrorModalState({ error: err });
      });
  };
  
  const handleWithCombinedOld = (certificates) => {
    return certificates?.map((certificate, index) => {
      return (
        <Box
          key={certificate.name}
          className={
            index + 1 < certificatesList.length
              ? styles.labelgroup
              : styles.labelgrouplast
          }
        >
          <Box className={styles.assignlabelstyle}>
            {getLogoIcon(certificate.certificate_Name, index, "")}
            <span className={styles.hyphen}>-</span>
            <span className={styles.date}>
              {!_.isEmpty(certificate.updatedDate)
                ? moment(certificate.updatedDate).format("DD-MM-YYYY")
                : ""}
            </span>
          </Box>
          <Box className={styles.assignlabelicon}>
            <Box
              className={styles.file}
              onClick={() => handleViewCertificate(vehicleId, certificate)}
              onKeyDown={() => { }}
            ></Box>

            <Box
              className={styles.mail}
              onClick={() => sentMail(certificate)}
              onKeyDown={() => { }}
            ></Box>
            <Box
              className={styles.trash}
              onClick={() => {
                setIsShowModalFlag(true);
                setDeleteCertificate(certificate);
              }}
              onKeyDown={() => { }}
              data-testid="delete"
            ></Box>
          </Box>
        </Box>

      );
    });
  };
  const handleWithOutCombined = (certificate) => {
    return certificatesList?.map((certificate, index) => {
      return (
        <Box
          key={certificate.name}
          className={
            index + 1 < certificatesList.length
              ? styles.labelgroup
              : styles.labelgrouplast
          }
        >
          <Box className={styles.assignlabelstyle}>
            {getLogoIcon(certificate.certificate_Name, index, "")}
            <span className={styles.hyphen}>-</span>
            <span className={styles.date}>
              {!_.isEmpty(certificate.updatedDate)
                ? moment(certificate.updatedDate).format("DD-MM-YYYY")
                : ""}
            </span>
          </Box>
          <Box className={styles.assignlabelicon}>
            <Box
              className={styles.file}
              onClick={() => handleViewCertificate(vehicleId, certificate)}
              onKeyDown={() => { }}
            ></Box>

            <Box
              className={styles.mail}
              onClick={() => sentMail(certificate)}
              onKeyDown={() => { }}
            ></Box>
            <Box
              className={styles.trash}
              onClick={() => {
                setIsShowModalFlag(true);
                setDeleteCertificate(certificate);
              }}
              onKeyDown={() => { }}
              data-testid="delete"
            ></Box>
          </Box>
        </Box>
      );
    });
  };

  const handleWithCombined = (certificatesList) => {
    // certificatesList?.unshift(certificatesList?.pop());
    const customOrder = ["Combined_Certificate", "Status_Label4", "Status_Checked_Go", "Status_Label3", "Status_100OH", "Status_Label5"];
    const reOrdered = customOrder.map(name => certificatesList?.find(cert => cert['certificate_Name'] === name)).filter(cert => cert !== undefined)
    return reOrdered?.map((certificate, index) => {
      return (
        <Box
          key={certificate?.certificate_Name}
          className={
            index + 1 < reOrdered.length
              ? styles.labelgroup
              : styles.labelgrouplast
          }
        >
          <Box className={styles.assignlabelstyle}>
            {getLogoIcon(certificate?.certificate_Name, index, "")}
            <span className={styles.hyphen}>-</span>
            <span className={styles.date}>
              {!_.isEmpty(certificate.updatedDate)
                ? moment(certificate.updatedDate).format("DD-MM-YYYY")
                : ""}
            </span>
          </Box>
          <Box sx={{ display: certificate?.certificate_Name === "Combined_Certificate" ? "block" : "none" }}>
            <Box className={styles.assignlabelicon} >
              <Box
                className={styles.file}
                onClick={() => handleViewCertificate(vehicleId, certificate)}
                onKeyDown={() => { }}
              ></Box>

              <Box
                className={styles.mail}
                onClick={() => sentMail(certificate)}
                onKeyDown={() => { }}
              ></Box>
              <Box
                className={styles.trash}
                onClick={() => {
                  setIsShowModalFlag(true);
                  setDeleteCertificate(certificate);
                }}
                onKeyDown={() => { }}
                data-testid="delete"
              ></Box>
            </Box>
          </Box>
        </Box>
      );
    });
  }
  return (
    <>
      <Box className={styles.assignLabelsWrapper} data-testid="vehicleicon">
        {_.isEmpty(combainedCertificate)
          ? handleWithOutCombined(certificatesList)
          : <Box>{handleWithCombined(certificatesList)}</Box>}
      </Box>
      {isShowModalFlag ? (
        <CustomModalDialog
          title={"Delete certificate"}
          isShow={isShowModalFlag}
          onClose={() => setIsShowModalFlag(false)}
          className={"modal-dialog"}
          isCloseButton={true}
          hasFooter={false}
        >
          <UpdateVehicleStatus
            handleDelete={() => {
              handleDeleteCertificate(vehicleId, deleteCertificate);
              setIsShowModalFlag(false);
            }}
            handleCancel={() => setIsShowModalFlag(false)}
          />
        </CustomModalDialog>

      ) : (
        ""
      )}
      <LoaderSpinnerComponent open={isShowLoader}/>
    </>
  );
};

export default VehicelIconComponent;
VehicelIconComponent.propTypes = {
  vehicleId: PropTypes.any,
  certificatesList: PropTypes.any,
  refreshTable: PropTypes.any,
  vehicle: PropTypes.any,
  setOpenSnackBar: PropTypes.any,
  setEmailStatus: PropTypes.any,
};
